"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthlyUsageDefinition = exports.usageDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.usageDefinition = (0, firestore_1.defineCollection)({
    collectionName: "usage",
    idKey: "userId",
    parent: project_1.projectDefinition,
    constraints: ["projectId"],
    queryDefs: {},
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
exports.monthlyUsageDefinition = (0, firestore_1.defineCollection)({
    collectionName: "monthly",
    idKey: "month",
    parent: exports.usageDefinition,
    constraints: ["projectId", "userId"],
    queryDefs: {
        list: ({ projectId, userId }) => {
            return projectId && userId
                ? {
                    constraint: { projectId, userId },
                    queryParams: {},
                    // queryParams: {
                    //   orderBy: [["month", "desc"]],
                    // },
                }
                : undefined;
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
